import { footballGoalRowDarkSrc, footballGoalRowSrc } from '@/common/assets';
import { useTheme } from '@/common/hooks';
import { T } from '@/common/enums';

export default function FootballGoalRowImage() {
  const { theme } = useTheme();
  const src = theme === T.DARK ? footballGoalRowDarkSrc : footballGoalRowSrc;

  return (
    <img
      alt="Football goal"
      className="pointer-events-none mx-auto block h-[72px] w-auto max-w-full min-w-0 object-contain"
      src={src}
    />
  );
}
